import React, { useState, useEffect, useContext } from "react";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LoadingFlashDeals from "./LoadingFlashDeals";
import {MdInfoOutline} from 'react-icons/md'
import { Link } from 'react-router-dom';
import { DataContext } from "../Context";

const SampleNextArrow = (props) => {
  const { onClick } = props;

  return (
    <div className="control-btn" onClick={onClick}>
      <button className="next">
        <i className="fa fa-long-arrow-alt-right"></i>
      </button>
    </div>
  );
};
const SamplePrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="control-btn" onClick={onClick}>
      <button className="prev">
        <i className="fa fa-long-arrow-alt-left"></i>
      </button>
    </div>
  );
};
const FlashCard = ({ productItems, addToCart }) => {
  const [count, setCount] = useState(0);
  const increment = () => {
    setCount(count + 1);
  };

  const settings = {
    dots: false,
    // infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    swipeToSlide: false,
    intialSlide: 0,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const baseURLProductos = "https://72jjtpdj.directus.app/items/productos?&sort=-descuento&?limit=-1";
  const baseImage = "https://72jjtpdj.directus.app/assets/";
  const [productos, setProductos] = useState([]);
  const {precioValue,errorDolarAPI} = useContext(DataContext)

  useEffect(() => {
    axios.get(baseURLProductos).then((response) => {
      setProductos(response.data.data);
    });
  }, []);

  const crearObjeto = (
    nombre,
    precioOriginal,
    descuento,
    imagen,
    id,
    precioDescuento
  ) => {
    let precioCambioDolar = precioValue * precioDescuento;
    let productItem = {
      imagen: imagen,
      descuento: descuento,
      id: id,
      nombre: nombre,
      precio: precioCambioDolar,
    };

    addToCart(productItem);
  };
  let filtrado = productos.filter((item) => item.descuento > 0)



  return (
    <>
      <Slider {...settings}>
        {filtrado.length === 0 &&
          new Array(8)
            .fill()
            .map((item, index) => <LoadingFlashDeals key={index} />)}

        {filtrado.map((productItems, index) => {
          return (
            <div key={index} className="box">
              <div className="product_item_flash product-flashdeals">
                <div className="img">
                  <span className="discount">
                    {productItems.descuento}% Off
                  </span>
                  <img
                    src={`${baseImage + productItems.imagen}`}
                    alt={productItems.nombre}
                    className="img-1"
                  />
                </div>
                <div className="product-details">
                  <h3>{productItems.nombre}</h3>
                  <div className="rate">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </div>
                  <div className="price">
                    <div className="flex-textos-precios">
                      <h4>
                        Precio:{" "}
                        <span
                          style={{
                            textDecorationLine: "line-through",
                            textDecorationStyle: "solid",
                          }}
                        >
                          {errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(productItems.precio * precioValue)}
                        </span>
                      </h4>
                      <h4>
                        Ahora: {errorDolarAPI ? "USD" : "AR$"}{" "}
                        {Intl.NumberFormat('de-DE').format(productItems.precio * precioValue -
                          (parseInt(productItems.descuento) *
                            (productItems.precio * precioValue)) / 100)}
                      </h4>
                    </div>
                    {/* step : 3
                    if hami le button ma click garryo bahne
                    */}
                     <button><Link to={`/productDetails/${productItems.id}`}>   <i className="fas fa-info-circle"></i> </Link></button>
                    <button
                      onClick={() =>
                        crearObjeto(
                          productItems.nombre,
                          productItems.precio,
                          productItems.descuento,
                          productItems.imagen,
                          productItems.id,
                          parseInt(productItems.precio) -
                          (parseInt(productItems.descuento) *
                            parseInt(productItems.precio)) /
                          100
                        )
                      }
                    >
                      <i className="fa fa-plus"></i>
                    </button>
                    
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </>
  );
};

export default FlashCard;
